import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "./PolicyPages.css";

const faqData = [
  {
    category: "Courses",
    question: "Are CODEION courses live or recorded?",
    answer:
      "Program delivery depends on the selected course. A program may include live sessions, recorded learning resources, assignments, projects, and mentor support. Please review the specific program details before enrolling.",
  },
  {
    category: "Courses",
    question: "Who can enroll in CODEION programs?",
    answer:
      "CODEION programs are designed for learners such as students, fresh graduates, beginners, developers, and professionals who want to build or strengthen practical technology skills.",
  },
  {
    category: "Certificates",
    question: "Will I receive a certificate?",
    answer:
      "Selected programs may provide completion certificates when the learner satisfies the applicable attendance, assignment, project, payment, and other completion requirements.",
  },
  {
    category: "Career Support",
    question: "Does CODEION guarantee placement?",
    answer:
      "No. CODEION may provide career-focused learning, resume guidance, interview preparation, projects, or other support depending on the program, but employment, internships, salaries, and placement outcomes are not guaranteed.",
  },
  {
    category: "Payments",
    question: "How can I pay the course fee?",
    answer:
      "Payments should be completed only through CODEION's official website or other payment channels explicitly authorized by CODEION.",
  },
  {
    category: "Refunds",
    question: "Can I request a refund?",
    answer:
      "Refund requests are reviewed according to the eligibility requirements, timelines, exclusions, and procedures described in the CODEION Refund Policy.",
  },
  {
    category: "Account",
    question: "I cannot log in to my account. What should I do?",
    answer:
      "Check that you are using the correct email address and login method. If the issue continues, contact CODEION support with your registered email address and a description of the problem.",
  },
  {
    category: "Support",
    question: "How can I contact CODEION support?",
    answer:
      "You can contact the CODEION support team at support@codeion.in. Support hours are Monday to Saturday, 10:00 AM to 7:00 PM IST.",
  },
];

function Faq() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="support-page">
      <Navbar />

      <main className="support-main">
        <div className="support-wrapper">
          <section className="support-hero">
            <span className="legal-eyebrow">CODEION SUPPORT</span>

            <h1>Frequently Asked Questions</h1>

            <p>
              Find quick answers about CODEION courses, certificates, payments,
              refunds, accounts, career support, and platform services.
            </p>

            <div className="support-hero-actions">
              <a href="#faq-list" className="support-primary-button">
                Browse Questions ↓
              </a>

              <a
                href="mailto:support@codeion.in"
                className="support-secondary-button"
              >
                Contact Support
              </a>
            </div>
          </section>

          <section className="support-stats">
            <div>
              <strong>Courses</strong>
              <span>Program & learning information</span>
            </div>

            <div>
              <strong>Payments</strong>
              <span>Fees, transactions & refunds</span>
            </div>

            <div>
              <strong>Accounts</strong>
              <span>Login & platform assistance</span>
            </div>
          </section>

          <section id="faq-list" className="faq-section">
            <div className="support-section-heading">
              <span>HELPFUL ANSWERS</span>
              <h2>Everything you need to know</h2>
              <p>
                Select a question below to view more information.
              </p>
            </div>

            <div className="faq-list">
              {faqData.map((faq, index) => {
                const isOpen = activeIndex === index;

                return (
                  <article
                    className={`faq-card ${isOpen ? "faq-card-open" : ""}`}
                    key={faq.question}
                  >
                    <button
                      type="button"
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isOpen}
                    >
                      <div>
                        <span className="faq-category">{faq.category}</span>
                        <h3>{faq.question}</h3>
                      </div>

                      <span className="faq-toggle">
                        {isOpen ? "−" : "+"}
                      </span>
                    </button>

                    {isOpen && (
                      <div className="faq-answer">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </section>

          <section className="support-cta">
            <div>
              <span className="legal-eyebrow">STILL NEED HELP?</span>
              <h2>Couldn't find the answer you need?</h2>

              <p>
                Contact the CODEION support team for help with courses,
                accounts, payments, enrollments, or platform access.
              </p>
            </div>

            <a
              href="mailto:support@codeion.in"
              className="support-primary-button"
            >
              Contact Support →
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Faq;